import { Stack, Typography, Icon } from "@mui/material";
import { ReactElement } from "react";

interface Props {
    title: string;
    icon: ReactElement;
    children: ReactElement;
}

const Section = ({ title, icon, children }: Props) => {
    return (
        <Stack spacing={2}>
            <Typography
            variant="h3"
            sx={{ gap: 1, display: 'flex', alignItems: 'center' }}
            >
            { icon ? (
                <Icon>
                    {icon}
                </Icon>
            ) : null}
                {title}
            </Typography>
            {children}
        </Stack>
    )
}

export default Section;
